import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';

import { NavRoute } from '../../shared/navigation/nav.route.interface';

export const getMainNavHelp: () => NavRoute = () => {
	return {
		name: 'Help'
        , exact: true
        , path: `help`
        , icon: faQuestionCircle
        , area: 'help'
        , expanded: globalThis.location.href.includes("/help/")
        , security: sec => sec.coreFeatures
        ,  children: [
			{
				name: 'Documents'
				, exact: true
				, path: 'help'
                , activeNavLink: 'help'
                , secondaryNav: ['Help', 'Documents']
			}
            , {
				name: 'Release Notes'
				, exact: true
				, path: 'release-notes'
                , activeNavLink: 'release-notes'
                , secondaryNav: ['Help', 'Release Notes']
			}
		]
	};
};